"use es6";

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

import { gapi } from "gapi-script";
import jwt_decode from "jwt-decode";
import Button from "../Buttons/Button";
import H1 from "../Text/H1";

import swap from "../../graphics/icons/swap.svg";
import H3 from "../Text/H3";
import H2 from "../Text/H2";
import P from "../Text/P";
import HR from "../Text/HR";
import Viewport from "./Viewport";

import countries from "../../translations/countries.json";

const PurchaseViewport = ({
  isDesktop = null,
  children = "[insert text]",
  credentials = null,
  setCredentials = {},
  updateCredentials = {},
  language = null,
  translation = null,
  purchaseViewportVisible = false,
  setPurchaseViewportVisible = {},
}) => {
  const navigate = useNavigate();

  const [newCountry, setNewCountry] = useState("");

  const [isSwapping, setIsSwapping] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const requestConfig = {
    headers: {
      "x-api-key": process.env.REACT_APP_API_KEY,
    },
  };

  const handleSubmit = async () => {
    setIsSwapping(true);
    if (newCountry === "") {
      setIsSwapping(false);
      setErrorMessage("Please select a new country before continuing.");
      return;
    }

    setErrorMessage(null);

    const requestBody = {
      country: newCountry,
    };

    await axios
      .post(
        `${process.env.REACT_APP_ACCOUNTS_API_URL}/accounts/${credentials.id}`,
        requestBody,
        requestConfig
      )
      .then((res) => {
        updateCredentials(res.data.account);
        setPurchaseViewportVisible(false);
      })
      .catch((error) => {
        setErrorMessage(error.response.data.message);
      });
  };

  return (
    <Viewport
      isDesktop={isDesktop}
      heading={translation.navigation.purchase_credits}
      viewportVisible={purchaseViewportVisible}
      setViewportVisible={setPurchaseViewportVisible}
    >
      <div style={{ height: 10 }} />
      <div
        style={{
          margin: "auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          textAlign: "center",
          maxHeight: isDesktop ? 550 : "100%",
          overflowY: "scroll",
        }}
      >
        Coming soon!
      </div>
    </Viewport>
  );
};

export default PurchaseViewport;
